import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Clock } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal } from "@/components/site/Reveal";

const fmtPrice = (p) => (p === 0 ? "Gratuita" : `${p}€`);

export const Services = () => {
  const [services, setServices] = useState([]);
  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <section id="servicos" className="py-24 lg:py-36 bg-[#FAF7F7]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <Reveal>
            <span className="text-xs uppercase tracking-[0.25em] text-rose-800">Serviços</span>
            <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl text-stone-900 mt-4 max-w-xl leading-[1.02]">
              Consultas pensadas para si
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="text-stone-500 max-w-xs text-sm">
              Escolha a modalidade, o dia e a hora. O pagamento é efetuado no local, no dia da consulta.
            </p>
          </Reveal>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.08}>
              <Link
                to={`/marcacao?servico=${s.id}`}
                data-testid={`service-card-${s.id}`}
                className={`group flex flex-col justify-between h-full rounded-3xl p-8 border transition-[transform,box-shadow] duration-500 hover:-translate-y-1 ${
                  s.free
                    ? "bg-rose-800 text-white border-rose-800"
                    : "bg-white border-rose-100 hover:shadow-[0_24px_60px_-30px_rgba(159,18,57,0.35)]"
                }`}
              >
                <div>
                  <div className="flex items-center justify-between">
                    <span
                      className={`inline-flex items-center gap-1.5 text-xs ${
                        s.free ? "text-rose-100" : "text-stone-400"
                      }`}
                    >
                      <Clock className="w-3.5 h-3.5" /> {s.duration}
                    </span>
                    <ArrowUpRight
                      className={`w-5 h-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 ${
                        s.free ? "text-white" : "text-rose-700"
                      }`}
                    />
                  </div>
                  <h3 className={`font-display text-2xl mt-6 ${s.free ? "text-white" : "text-stone-900"}`}>
                    {s.name}
                  </h3>
                  <p className={`mt-3 text-sm leading-relaxed ${s.free ? "text-rose-50" : "text-stone-500"}`}>
                    {s.description}
                  </p>
                </div>
                <div className={`mt-8 pt-6 border-t ${s.free ? "border-rose-700" : "border-rose-50"}`}>
                  <span className={`font-display text-3xl ${s.free ? "text-white" : "text-stone-900"}`}>
                    {fmtPrice(s.price)}
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
